import { isSameSearchCriteria } from "domains/publication/reducer";
import type { RootState } from "types/redux";

export const createStakeholdersForTopicSelector = (id: string) => (state: RootState) =>
  state.domains.stakeholders.forTopic[id]?.find((item) =>
    isSameSearchCriteria(item.searchCriteria, { ...getStakeholdersSearchCriteria(state), id }),
  );

export const getStakeholdersSearchCriteria = (state: RootState) => state.domains.stakeholders.searchCriteria;

export const getIsStakeholdersFiltered = (state: RootState) => {
  const { role, search, type } = state.domains.stakeholders.searchCriteria;
  return !!role || !!search || !!type;
};

export const getStakeholderFilterCount = (state: RootState) => {
  const { role, search, type } = state.domains.stakeholders.searchCriteria;
  let count = 0;
  if (role) count++;
  if (search) count++;
  if (type) count++;
  return count;
};
